import { Outlet } from 'react-router-dom';
import { RouteErrorBoundary } from '@/components/ui/ErrorBoundary';
import { Sidebar, type NavSection } from '@/components/layout/Sidebar';
import { Topbar } from '@/components/layout/Topbar';
import { ToastHost } from '@/components/ui/Toast';
import { FloatingSoftphone } from '@/personas/agent/components/FloatingSoftphone';
import { WrapupOverlay } from '@/personas/agent/components/WrapupOverlay';
import { CustomerCard } from '@/personas/agent/components/CustomerCard';
import { useCustomerCardPop } from '@/personas/agent/hooks/useCustomerCardPop';
import { PersistentAudioBar } from '@/components/layout/PersistentAudioBar';
import { IncomingCallModal } from '@/personas/agent/components/IncomingCallModal';
import { useSipRegistration } from '@/personas/agent/stores/useSipRegistration';

const NAV: NavSection[] = [
  {
    he: 'סקירה',
    items: [
      { id: 'dashboard', to: '/super', he: 'דשבורד', icon: 'chart' },
      { id: 'health', to: '/super/health', he: 'ניטור תשתית', icon: 'bolt' },
      { id: 'notifications', to: '/super/notifications', he: 'מרכז התראות', icon: 'bell' },
      { id: 'reports', to: '/super/reports', he: 'דוחות מערכת', icon: 'doc' },
    ],
  },
  {
    he: 'לקוחות',
    items: [
      { id: 'tenants', to: '/super/tenants', he: 'ניהול לקוחות', icon: 'users' },
      { id: 'internal-users', to: '/super/internal-users', he: 'משתמשי-על', icon: 'lock' },
    ],
  },
  {
    he: 'מסחר',
    items: [
      { id: 'plans', to: '/super/plans', he: 'תוכניות מחיר', icon: 'tag' },
      { id: 'billing', to: '/super/billing', he: 'חיוב לפי שימוש', icon: 'chart' },
      { id: 'costs', to: '/super/costs', he: 'עלויות מערכת', icon: 'tag' },
      { id: 'invoices', to: '/super/invoices', he: 'חשבוניות', icon: 'doc' },
      { id: 'api', to: '/super/api', he: 'API & Webhooks', icon: 'bolt' },
    ],
  },
  {
    he: 'תשתית',
    items: [
      { id: 'trunks', to: '/super/trunks', he: 'קווי SIP', icon: 'phone' },
      { id: 'voice-agents', to: '/super/voice-agents', he: 'AI במערכת', icon: 'ai' },
      { id: 'mcp', to: '/super/mcp', he: 'חיבור Claude Code', icon: 'bolt' },
      { id: 'did-pool', to: '/super/did-pool', he: 'מאגר מספרים', icon: 'globe' },
      { id: 'audit', to: '/super/audit', he: 'לוג אירועים', icon: 'history' },
      { id: 'tickets', to: '/super/tickets', he: 'תמיכה', icon: 'mail' },
      { id: 'whitelabel', to: '/super/whitelabel', he: 'White Label', icon: 'flag' },
    ],
  },
];

export function SuperAdminLayout() {
  // Super-admins with an extension get the softphone too; without one it
  // registers in "no line" mode (toggle hidden).
  useSipRegistration('super');
  // כרטיס הלקוח נפתח אוטומטית בשיחה (הסופטפון הצף זמין גם כאן).
  useCustomerCardPop();

  return (
    <div style={{ display: 'flex', height: '100vh', overflow: 'hidden' }}>
      <a href="#main-content" className="skip-link">דלג לתוכן</a>
      <Sidebar brand="ספק פלטפורמה" sections={NAV} />
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', minWidth: 0 }}>
        <Topbar title="Super Admin" />
        <main id="main-content" aria-label="תוכן ראשי" style={{ flex: 1, overflow: 'auto' }}>
          <RouteErrorBoundary>
            <Outlet />
          </RouteErrorBoundary>
        </main>
      </div>
      <IncomingCallModal />
      {/* חייב להתלוות ל-FloatingSoftphone: הוא היחיד שקורא ל-finishWrapup,
          ובלעדיו הסופטפון נתקע ב-wrap-up אחרי שיחה ואי אפשר לחייג שוב. */}
      <WrapupOverlay />
      <CustomerCard />
      <FloatingSoftphone />
      <PersistentAudioBar />
      <ToastHost />
    </div>
  );
}
